import React from "react";
import KycFailWrapper from "./KycFail.style";
import FailsUI from "../../../../_shared/Failure/Failure";
import GoogleMap from "_shared/GoogleMapComp";
import Header from "_shared/Header/Header";
const KycFailMotor = (props) => {
	return (
		<KycFailWrapper>
			<>
				<div className="header mb-3">
					<Header />
				</div>
				<FailsUI />
				<GoogleMap iconClickable />
			</>
		</KycFailWrapper>
	);
};

export default KycFailMotor;
